import React from 'react';
import "./TopicSection.css";

import { Link, useParams } from 'react-router-dom';


const TopicSecion = () => {

  const { id } = useParams();
 

  let Nairaland = ['Nairaland / General: '," Politics, ", " Crime, ", " Romance, ", " Jobs/Vacancies, ", " Career, ", " Business, ", " Investment, ", " NYSC, ", " Education, ", " Autos, ", " Car, ", " Talk, ", " Property, ", " Health, ", " Travel, ", " Family, ", " Culture, ", " Religion, ", " Food, ", " Diaries, ", " Nairaland ads, ", " Pets, ", " Agriculture "]
  

  let  Entertainment = [ "Entertainment: "," Jokes Etc, ", " TV/Movies, ", "Music/Radio, ", "Celebrities, ", " Fashion, ", " Events, ", " Sports, ", " Gaming, ", " Forum Games, ", " Literature "]
  
  let Science = ["Science / Technology:","Programmer,", "Webmasters,", "Computers,", "Phones,", " Art,", " Graphics & Video,", "Technology Market,"]
  
  return (
    <div className='topicsection'>
      
      <div className="head">NAIRALAND NIGERIAN FORUM</div>
      <div className="top">
        <div className="section1 topic">  {
          Nairaland.map((key, val) => { return(<div key={key}><Link to={`/section/${key.replace(",", "").replace(" ", "")}`}>{ key }</Link> &nbsp;</div> )
            
})
          
         }</div>
       <div className="section2 topic1"> {
          Entertainment.map((key, val) => {
            return (<div key={key}><Link to={`/section/${key.replace(",", "")}`}>{key}</Link>&nbsp;</div>)
            
})
          
         }
        </div>
         <div className="section3 topic2" >  {
          Science.map((key, val) => {
            return (<div key={key}><Link to={`/section/${key.replace(",", "")}`}>{key}</Link>&nbsp;
            </div>)
            
})
          
         }</div>
        
      </div>

   
    </div>
  )
}

export default TopicSecion